import { render, staticRenderFns } from "./pinjamanlist.vue?vue&type=template&id=6b2387a6&"
import script from "./pinjamanlist.vue?vue&type=script&lang=js&"
export * from "./pinjamanlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports